import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Tabs, notification } from 'antd';

import ConsignmentImportPreloading from '@src/flc/components/logistics/import/consignments/consignment-import-preloading';
import ConsignmentNlPreloading from '@src/flc/components/logistics/import/consignments/consignment-nl-preloading';

import FormHeader from '@controls/form-header/form-header';

import { exception } from '@extensions/notification';
import { userLoaded } from '@store/actions';
import { useAppDispatch } from '@store/hooks';
import { ICity } from '@entities/city';
import { ITruck } from '@entities/truck';
import { ICountry } from '@entities/country';

import { serverFetch } from '@flc/server';

const ConsignmentPreloading = () => {
    const { truckId } = useParams();

    const d = useAppDispatch();

    const [api, contextHolder] = notification.useNotification();

    const [countries, setCountries] = useState<Array<ICountry>>([]);
    const [cities, setCities] = useState<Array<ICity>>([]);
    const [truck, setTruck] = useState<ITruck>();

    useEffect(() => {
        let cleanup = false;

        const fetchData = async () => {
            const promises = [
                await serverFetch(`countries`, { method: 'GET' })
                    .then((data: any) => {
                        return data;
                    })
                    .catch((ex: any) => {
                        exception(api, 'Ошибка получения стран', ex, () => d(userLoaded(undefined)));
                    }),
                await serverFetch(`cities`, { method: 'GET' })
                    .then((data: any) => {
                        return data;
                    })
                    .catch((ex: any) => {
                        exception(api, 'Ошибка получения городов', ex, () => d(userLoaded(undefined)));
                    }),
                await serverFetch(`trucks/${truckId}`, { method: 'GET' })
                    .then((data) => {
                        return data;
                    })
                    .catch((ex) => {
                        exception(api, 'Ошибка получения машины', ex, () => d(userLoaded(undefined)));
                    }),
            ];

            Promise.all([promises]).then((result) => {
                if (cleanup) return;

                setCountries(result[0][0]);
                setCities(result[0][1]);
                setTruck(result[0][2]);
            });
        };

        fetchData();
        return () => {
            cleanup = true;
        };
    }, []);

    const tabItems = [
        {
            label: `Нидерланды`,
            key: 'nl',
            children: (
                <ConsignmentNlPreloading
                    truck={truck}
                    cities={cities}
                    country={countries.find((c) => c.code == 'NL')}
                    api={api}
                    serverFetch={serverFetch}
                />
            ),
        },
        {
            label: `Импорт`,
            key: 'import',
            children: (
                <ConsignmentImportPreloading
                    truck={truck}
                    cities={cities}
                    countries={countries.filter((c) => c.code != 'NL')}
                    api={api}
                    serverFetch={serverFetch}
                />
            ),
        },
    ];

    return (
        <>
            <FormHeader title={`Добавить из предзагрузки в (${truck?.number})`} />
            <Tabs size='small' items={tabItems} style={{ marginTop: -10 }}></Tabs>
            {contextHolder}
        </>
    );
};

export default ConsignmentPreloading;
